import { Box, InputBase, Popover, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { putGroupSignUp2, putSetImageGroup } from "../../api/signin";
import { changeProfileGroup } from "../../api/user";
import defPicUser from "../../assets/image/defPicUser.png";
import AddPhotoIcon from "../../assets/SVG/addPhotoIcon";
import DeleteIcon from "../../assets/SVG/deleteIcon";
import DescriptionIcon from "../../assets/SVG/descriptionIcon";
import Group from "../../assets/SVG/group";
import PhoneIcon2 from "../../assets/SVG/phoneIcon2";
import ProfileIcon from "../../assets/SVG/profileIcon";
import SocialMedia from "../../assets/SVG/socialMedia";
import UploadIcon from "../../assets/SVG/uploadIcon";
import Vector from "../../assets/SVG/vector";
import InputLoginForm from "../login/inputLoginForm";
import SelectInput from "./selectInput";

export default function SigninGroupForm1({
  setLevel,
  dataForm,
  setDataForm,
  update,
}) {
  const [hover, setHover] = useState();
  const styleLabel = {
    color: "#2B2B2B",
    textAlign: "right",
    fontSize: "16px",
    fontWeight: "600",
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [lodgment, setLodgment] = useState(0);
  const [lodgmentFinal, setLodgmentFinal] = useState();
  const [tripFrequency, setTripFrequency] = useState(0);
  const [tripFrequencyFinal, setTripFrequencyFinal] = useState();
  const [establishYear, setEstablishYear] = useState(0);
  const [groupRegistrationPlace, setGroupRegistrationPlace] = useState(0);
  const [groupRegistrationPlaceFinal, setGroupRegistrationPlaceFinal] =
    useState();
  const [tripRadius, setTripRadius] = useState(0);
  const [tripRadiusFinal, setTripRadiusFinal] = useState();
  const [image, setImage] = useState();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  useEffect(() => {
    if (lodgment === "دفتر خصوصی") setLodgmentFinal("OFFICE");
    if (lodgment === "مسجد") setLodgmentFinal("MOSQUE");
    if (lodgment === "دانشگاه") setLodgmentFinal("UNIVERSITY");
    if (lodgment === "دفتر بسیج") setLodgmentFinal("BASIJ");
    if (lodgment === "سایر") setLodgmentFinal("OTHER");
  }, [lodgment]);

  useEffect(() => {
    if (lodgmentFinal) {
      setDataForm({ ...dataForm, lodgment: lodgmentFinal });
    }
  }, [lodgmentFinal]);
  useEffect(() => {
    if (tripFrequency === "دائمی") setTripFrequencyFinal("ALWAYS");
    if (tripFrequency === "هفتگی") setTripFrequencyFinal("WEEKLY");
    if (tripFrequency === "ماهانه") setTripFrequencyFinal("MONTHLY");
    if (tripFrequency === "فصلی") setTripFrequencyFinal("SEASONAL");
    if (tripFrequency === "دوبار در سال")
      setTripFrequencyFinal("TWICE_IN_YEAR");
    if (tripFrequency === "سالانه") setTripFrequencyFinal("YEARLY");
  }, [tripFrequency]);

  // useEffect(() => {
  //   setDataForm({ ...dataForm, tripFrequency: tripFrequencyFinal });
  // }, [tripFrequencyFinal]);
  useEffect(() => {
    if (tripFrequencyFinal) {
      setDataForm({
        ...dataForm,
        tripFrequency: tripFrequencyFinal,
      });
      console.log(tripFrequencyFinal);
      console.log(dataForm.tripFrequency);
    }
  }, [tripFrequencyFinal]);
  // console.log(tripFrequency);
  // console.log(tripFrequencyFinal);
  useEffect(() => {
    if (groupRegistrationPlace === "بسیج دانشجویی")
      setGroupRegistrationPlaceFinal("UNIVERSITY_BASIJ");
    if (groupRegistrationPlace === "بسیج جامعه پزشکی")
      setGroupRegistrationPlaceFinal("MEDICAL_BASIJ");
    if (groupRegistrationPlace === "بسیج محلات")
      setGroupRegistrationPlaceFinal("DISTINCT_BASIJ");
    if (groupRegistrationPlace === "دیگر بسیج‌ها")
      setGroupRegistrationPlaceFinal("OTHER_BASIJ");
    if (groupRegistrationPlace === "وزارت کشور")
      setGroupRegistrationPlaceFinal("COUNTRY_MINISTRY");
    if (groupRegistrationPlace === "وزارت بهداشت")
      setGroupRegistrationPlaceFinal("MEDICAL_MINISTRY");
    if (groupRegistrationPlace === "سپاه")
      setGroupRegistrationPlaceFinal("SEPAH");
    if (groupRegistrationPlace === "سایر")
      setGroupRegistrationPlaceFinal("OTHER");
  }, [groupRegistrationPlace]);

  useEffect(() => {
    setDataForm({
      ...dataForm,
      groupRegistrationPlace: groupRegistrationPlaceFinal,
    });
  }, [groupRegistrationPlaceFinal]);
  useEffect(() => {
    if (establishYear) {
      setDataForm({ ...dataForm, establishYear: establishYear });
    }
  }, [establishYear]);
  useEffect(() => {
    if (tripRadius === "در یک نقطه ثابت") setTripRadiusFinal("SPECIFIC_POINT");
    if (tripRadius === "در یک محله") setTripRadiusFinal("SPECIFIC_DISTINCT");
    if (tripRadius === "در یک شهر") setTripRadiusFinal("SPECIFIC_CITY");
    if (tripRadius === "در یک استان") setTripRadiusFinal("SPECIFIC_PROVINCE");
    if (tripRadius === "کشوری") setTripRadiusFinal("COUNTRY");
    if (tripRadius === "بین المللی") setTripRadiusFinal("INTERNATIONAL");
  }, [tripRadius]);
  useEffect(() => {
    setDataForm({ ...dataForm, tripRadius: tripRadiusFinal });
  }, [tripRadiusFinal]);

  useEffect(() => {
    if (dataForm.tripRadius === "SPECIFIC_POINT")
      setTripRadius("در یک نقطه ثابت");
    if (dataForm.tripRadius === "SPECIFIC_DISTINCT")
      setTripRadius("در یک محله");
    if (dataForm.tripRadius === "SPECIFIC_CITY") setTripRadius("در یک شهر");
    if (dataForm.tripRadius === "SPECIFIC_PROVINCE")
      setTripRadius("در یک استان");
    if (dataForm.tripRadius === "COUNTRY") setTripRadius("کشوری");
    if (dataForm.tripRadius === "INTERNATIONAL") setTripRadius("بین المللی");
    ////////////////////////////////////////////////////////////////
    if (dataForm.groupRegistrationPlace === "UNIVERSITY_BASIJ")
      setGroupRegistrationPlace("بسیج دانشجویی");
    if (dataForm.groupRegistrationPlace === "MEDICAL_BASIJ")
      setGroupRegistrationPlace("بسیج جامعه پزشکی");
    if (dataForm.groupRegistrationPlace === "DISTINCT_BASIJ")
      setGroupRegistrationPlace("بسیج محلات");
    if (dataForm.groupRegistrationPlace === "OTHER_BASIJ")
      setGroupRegistrationPlace("دیگر بسیج‌ها");
    if (dataForm.groupRegistrationPlace === "COUNTRY_MINISTRY")
      setGroupRegistrationPlace("وزارت کشور");
    if (dataForm.groupRegistrationPlace === "MEDICAL_MINISTRY")
      setGroupRegistrationPlace("وزارت بهداشت");
    if (dataForm.groupRegistrationPlace === "SEPAH")
      setGroupRegistrationPlace("سپاه");
    if (dataForm.groupRegistrationPlace === "OTHER")
      setGroupRegistrationPlace("سایر");
    //////////////////////////////////////////////////////////////////
    if (dataForm.tripFrequency === "ALWAYS") setTripFrequency("دائمی");
    if (dataForm.tripFrequency === "WEEKLY") setTripFrequency("هفتگی");
    if (dataForm.tripFrequency === "MONTHLY") setTripFrequency("ماهانه");
    if (dataForm.tripFrequency === "SEASONAL") setTripFrequency("فصلی");
    if (dataForm.tripFrequency === "TWICE_IN_YEAR")
      setTripFrequency("دوبار در سال");
    if (dataForm.tripFrequency === "YEARLY") setTripFrequency("سالانه");
    ///////////////////////////////////////////////////////////////////
    if (dataForm.lodgment === "OFFICE") setLodgment("دفتر خصوصی");
    if (dataForm.lodgment === "MOSQUE") setLodgment("مسجد");
    if (dataForm.lodgment === "UNIVERSITY") setLodgment("دانشگاه");
    if (dataForm.lodgment === "BASIJ") setLodgment("دفتر بسیج");
    if (dataForm.lodgment === "OTHER") setLodgment("سایر");
  }, []);
  console.log(tripRadius, tripRadiusFinal);
  console.log(dataForm);

  const onChangeValueImage = (event) => {
    const file = event.target.files[0];
    let url = window?.URL?.createObjectURL(file);

    setImage({ file: file, url: url });
    handleClose();
  };
  useEffect(() => {
    if (image) {
      let formDataImage = new FormData();
      formDataImage.append("file", image.file);
      changeProfileGroup(formDataImage)
        .then(() => console.log("shod"))
        .catch((err) => console.log("nashod"));
      // console.log(image);
    }
  }, [image]);
  useEffect(() => {
    if (dataForm.lodgment === "UNIVERSITY_BASIJ")
      setGroupRegistrationPlace("بسیج دانشجویی");
    if (dataForm.lodgment === "MEDICAL_BASIJ")
      setGroupRegistrationPlace("بسیج جامعه پزشکی");
    if (dataForm.lodgment === "DISTINCT_BASIJ")
      setGroupRegistrationPlace("بسیج محلات");
    if (dataForm.lodgment === "OTHER_BASIJ")
      setGroupRegistrationPlace("دیگر بسیج‌ها");
    if (dataForm.lodgment === "COUNTRY_MINISTRY")
      setGroupRegistrationPlace("وزارت کشور");
    if (dataForm.lodgment === "MEDICAL_MINISTRY")
      setGroupRegistrationPlace("وزارت بهداشت");
    if (dataForm.lodgment === "SEPAH") setGroupRegistrationPlace("سپاه");
    // if (dataForm.lodgment === "OTHER") setGroupRegistrationPlace("سایر");
  }, [dataForm?.lodgment]);

  return (
    <>
      <Popover
        sx={{
          "& .MuiPaper-root": {
            width: "100px",
            padding: "10px 10px",
            borderRadius: "13px",
            mt: "10px",
            bgcolor: "#F3F3F3",
          },
        }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box>
          <Box sx={{ cursor: "pointer" }} display="flex" alignItems="center">
            <UploadIcon />
            <Typography
              sx={{ cursor: "pointer" }}
              variant="contained"
              component="label"
              mr="5px"
              fontSize="11px"
            >
              <input
                // value={props.value}
                // onKeyDown={props.onKeyDown}
                onChange={onChangeValueImage}
                hidden
                accept={"image/gif,.jpg,.png, .WebP,.JPEG"}
                multiple
                type="file"
              />
              {"بارکذاری عکس"}
            </Typography>
          </Box>
          <Box
            mt="10px"
            sx={{ cursor: "pointer" }}
            display="flex"
            alignItems="center"
            onClick={() => {
              setImage();
              handleClose();
            }}
          >
            <DeleteIcon />
            <Typography mr="5px" fontSize="11px" color="var(--emr-red)">
              {"حذف عکس"}
            </Typography>
          </Box>
        </Box>
      </Popover>
      <Box mb="50px" display={"flex"} gap="100px" width="90%">
        <Box width="70%">
          <Typography color="#126E83" fontSize="20px">
            {"مشخصات گروه"}
          </Typography>

          <Box
            onClick={handleClick}
            width="120px"
            height="120px"
            mt="25px"
            position="relative"
          >
            <img
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                position: "absolute",
                // border: " 1px solid rgba(18, 110, 131, 0.81)",
              }}
              onMouseEnter={() => {
                setHover(true);
              }}
              className="imageHover"
              src={image?.url || defPicUser}
            />
            {hover && (
              <Box
                onMouseLeave={() => {
                  setHover(false);
                }}
                width="120px"
                borderRadius="50%"
                position="absolute"
                height="120px"
                bgcolor="#00000090"
                display="grid"
                justifyItems="center"
                alignContent="center"
                sx={{ cursor: "pointer" }}
              >
                <AddPhotoIcon />
                <Typography color="white" mt="10px">
                  {"ویرایش عکس"}
                </Typography>
              </Box>
            )}
          </Box>
          <InputLoginForm
            main
            onChange={(e) =>
              setDataForm({ ...dataForm, groupName: e.target.value })
            }
            sx={{
              "&.MuiInputBase-root ": {
                width: "75% !important",
              },
            }}
            value={dataForm.groupName}
            lable="نام گروه"
            placeholder="نام گروه جهادی خود را وارد نمایید."
          >
            <Group color="#959595" />
          </InputLoginForm>
          <Typography mt="20px" sx={styleLabel} display="flex">
            {"تعداد کل اردوها / تعداد اردوهای سال اخیر"}
            <Typography color="red" mr="5px">
              *
            </Typography>
          </Typography>
          <Box display="flex" gap="20px">
            <Box
              sx={{
                border: "solid 1px var(--emr-borderInput)",
                borderRadius: "8px",
                px: "10px",
                height: "50px",
                display: "flex",
                mt: "5px",
                boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <InputBase
                onChange={(e) =>
                  setDataForm({
                    ...dataForm,
                    totalTrips: Number(e.target.value.replace(/\D/g, "")),
                  })
                }
                value={dataForm.totalTrips}
                placeholder="تعداد را وارد کنید."
              />
            </Box>
            <Box
              sx={{
                border: "solid 1px var(--emr-borderInput)",
                borderRadius: "8px",
                px: "10px",
                height: "50px",
                display: "flex",
                mt: "5px",
                boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <InputBase
                onChange={(e) =>
                  setDataForm({
                    ...dataForm,
                    recentTrips: Number(e.target.value.replace(/\D/g, "")),
                  })
                }
                value={dataForm.recentTrips}
                placeholder="تعداد را وارد کنید."
              />
            </Box>
          </Box>
          <Typography mt="20px" sx={styleLabel} display="flex">
            {"تعداد کل جهادگران / تعداد جهادگران فعال"}
            <Typography color="red" mr="5px">
              *
            </Typography>
          </Typography>
          <Box display="flex" gap="20px">
            <Box
              sx={{
                border: "solid 1px var(--emr-borderInput)",
                borderRadius: "8px",
                px: "10px",
                height: "50px",
                display: "flex",
                mt: "5px",
                boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <InputBase
                onChange={(e) =>
                  setDataForm({
                    ...dataForm,
                    totalMembers: Number(e.target.value.replace(/\D/g, "")),
                  })
                }
                value={dataForm.totalMembers}
                placeholder="تعداد را وارد کنید."
              />
            </Box>
            <Box
              sx={{
                border: "solid 1px var(--emr-borderInput)",
                borderRadius: "8px",
                px: "10px",
                height: "50px",
                display: "flex",
                mt: "5px",
                boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <InputBase
                onChange={(e) =>
                  setDataForm({
                    ...dataForm,
                    recentMembers: Number(e.target.value.replace(/\D/g, "")),
                  })
                }
                value={dataForm.recentMembers}
                placeholder="تعداد را وارد کنید."
              />
            </Box>
          </Box>
          <Typography mt="20px" sx={styleLabel} display="flex">
            {"تعداد روز اردو / تعداد کل مناطق"}
            <Typography color="red" mr="5px">
              *
            </Typography>
          </Typography>
          <Box display="flex" gap="20px">
            <Box
              sx={{
                border: "solid 1px var(--emr-borderInput)",
                borderRadius: "8px",
                px: "10px",
                height: "50px",
                display: "flex",
                mt: "5px",
                boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <InputBase
                onChange={(e) =>
                  setDataForm({
                    ...dataForm,
                    tripDays: Number(e.target.value.replace(/\D/g, "")),
                  })
                }
                value={dataForm.tripDays}
                placeholder="تعداد را وارد کنید."
              />
            </Box>
            <Box
              sx={{
                border: "solid 1px var(--emr-borderInput)",
                borderRadius: "8px",
                px: "10px",
                height: "50px",
                display: "flex",
                mt: "5px",
                boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <InputBase
                onChange={(e) =>
                  setDataForm({
                    ...dataForm,
                    regionsCount: Number(e.target.value.replace(/\D/g, "")),
                  })
                }
                value={dataForm.regionsCount}
                placeholder="تعداد را وارد کنید."
              />
            </Box>
          </Box>
          <InputLoginForm
            main
            onChange={(e) => setDataForm({ ...dataForm, site: e.target.value })}
            value={dataForm.site}
            mt="20px"
            lable="آدرس سایت"
            placeholder="آدرس سایت گروه جهادی را وارد نمایید"
          ></InputLoginForm>
          <Typography mt="20px" sx={styleLabel} display="flex">
            {"محل استقرار گروه"}
            <Typography color="red" mr="5px">
              *
            </Typography>
          </Typography>
          <SelectInput
            value={lodgment}
            setValue={setLodgment}
            setValueInput={setLodgmentFinal}
            valueInput={lodgmentFinal}
            width="430px"
            data={["دفتر خصوصی", "مسجد", "دانشگاه", "دفتر بسیج", "سایر"]}
            placeholder="انتخاب کنید"
          />
          <Typography mt="20px" sx={styleLabel} display="flex">
            {"بسامد برگذاری اردوها"}
            <Typography color="red" mr="5px">
              *
            </Typography>
          </Typography>
          <SelectInput
            valueInput={tripFrequencyFinal}
            setValueInput={setTripFrequencyFinal}
            value={tripFrequency}
            setValue={setTripFrequency}
            width="430px"
            data={[
              "دائمی",
              "هفتگی",
              "ماهانه",
              "فصلی",
              "دوبار در سال",
              "سالانه",
            ]}
            placeholder="انتخاب کنید"
          />

          <InputLoginForm
            main
            onChange={(e) =>
              setDataForm({ ...dataForm, address: e.target.value })
            }
            value={dataForm.address}
            lable="نشانی پایگاه"
            placeholder={"نشانی پایگاه را بطور کامل وارد نمایید"}
          ></InputLoginForm>
          <Box height="100px"></Box>
        </Box>
        <Box mt="185px" width="80%">
          <Typography display="flex" sx={styleLabel}>
            {"سال تاسیس گروه"}
            <Typography color="red" mr="5px">
              *
            </Typography>
          </Typography>
          <SelectInput
            value={dataForm.establishYear || establishYear}
            setValue={setEstablishYear}
            width="430px"
            data={[
              "1350",
              "1351",
              "1352",
              "1353",
              "1354",
              "1355",
              "1356",
              "1357",
              "1358",
              "1358",
              "1360",
              "1361",
              "1362",
              "1363",
              "1364",
              "1365",
              "1366",
              "1367",
              "1367",
              "1368",
              "1370",
              "1370",
              "1372",
              "1373",
              "1374",
              "1375",
              "1376",
              "1377",
              "1378",
              "1379",
              "1380",
              "1381",
              "1382",
              "1383",
              "1384",
              "1385",
              "1386",
              "1387",
              "1388",
              "1389",
              "1390",
              "1391",
              "1392",
              "1393",
              "1394",
              "1395",
              "1396",
              "1397",
              "1398",
              "1399",
              "1400",
              "1401",
              "1402",
              "1403",
              "1404",
            ]}
            placeholder="سال"
          />
          <InputLoginForm
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                atlasCode: e.target.value.replace(/\D/g, ""),
              })
            }
            value={dataForm.atlasCode}
            mt="20px"
            lable={"کداطلس جهادگران یا شناسه ملی"}
            placeholder="کداطلس یا شناسه ملی را وارد نمایید"
          >
            <DescriptionIcon />
          </InputLoginForm>
          <Typography mt="20px" sx={styleLabel} display="flex">
            {"تعداد نفر اردو / تعداد افراد تیم مدیریتی شما"}
            <Typography color="red" mr="5px">
              *
            </Typography>
          </Typography>
          <Box display="flex" gap="20px">
            <Box
              sx={{
                border: "solid 1px var(--emr-borderInput)",
                borderRadius: "8px",
                px: "10px",
                height: "50px",
                display: "flex",
                mt: "5px",
                boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <InputBase
                onChange={(e) =>
                  setDataForm({
                    ...dataForm,
                    membersPerTrip: Number(e.target.value.replace(/\D/g, "")),
                  })
                }
                value={dataForm.membersPerTrip}
                placeholder="تعداد را وارد کنید."
              />
            </Box>
            <Box
              sx={{
                border: "solid 1px var(--emr-borderInput)",
                borderRadius: "8px",
                px: "10px",
                height: "50px",
                display: "flex",
                mt: "5px",
                boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <InputBase
                onChange={(e) =>
                  setDataForm({
                    ...dataForm,
                    managersCount: Number(e.target.value.replace(/\D/g, "")),
                  })
                }
                value={dataForm.managersCount}
                placeholder="تعداد را وارد کنید."
              />
            </Box>
          </Box>
          <InputLoginForm
            main
            onChange={(e) =>
              setDataForm({ ...dataForm, pageAddress: e.target.value })
            }
            value={dataForm.pageAddress}
            mt="20px"
            lable={"آدرس پیج"}
            placeholder="آدرس پیج گروه جهادی را وارد نمایید."
          >
            <SocialMedia />
          </InputLoginForm>
          <InputLoginForm
            main
            onChange={(e) =>
              setDataForm({ ...dataForm, platform: e.target.value })
            }
            value={dataForm.platform}
            mt="20px"
            lable={"پلت‌فرم"}
            placeholder="پلت‌فرم را وارد نمایید"
          >
            <DescriptionIcon />
          </InputLoginForm>
          <Typography mt="20px" sx={styleLabel} display="flex">
            {"محل ثبت نام"}
            <Typography color="red" mr="5px">
              *
            </Typography>
          </Typography>
          <SelectInput
            value={groupRegistrationPlace}
            setValue={setGroupRegistrationPlace}
            valueInput={groupRegistrationPlaceFinal}
            setValueInput={setGroupRegistrationPlaceFinal}
            width="430px"
            data={[
              "بسیج دانشجویی",
              "بسیج جامعه پزشکی",
              "بسیج محلات",
              "دیگر بسیج‌ها",
              "وزارت کشور",
              "وزارت بهداشت",
              "سپاه",
              "سایر",
            ]}
            placeholder="انتخاب کنید"
          />
          <Typography mt="20px" sx={styleLabel} display="flex">
            {"شعاع برگزاری اردو"}
            <Typography color="red" mr="5px">
              *
            </Typography>
          </Typography>
          <SelectInput
            value={tripRadius}
            setValue={setTripRadius}
            width="430px"
            data={[
              "در یک نقطه ثابت",
              "در یک محله",
              "در یک شهر",
              "در یک استان",
              "کشوری",
              "بین المللی",
            ]}
            placeholder="انتخاب کنید"
          />
          <InputLoginForm
            main
            inputProps={{ maxLength: 11 }}
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                tel: e.target.value.replace(/\D/g, ""),
              })
            }
            value={dataForm.tel}
            lable={"تلفن ثابت"}
            placeholder="شماره تلفن ثابت دفتر را وارد نمایید"
          >
            <PhoneIcon2 />
          </InputLoginForm>
          <Box display="flex" justifyContent="center" mt="20px">
            {/* <button
              style={{
                border: "none",
                width: "150px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "white",
                // boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                padding: "12px 0px",
                marginTop: "20px",
                borderRadius: "8px",
              }}
              onClick={() => {
                setLevel(1);
              }}
            >
              <Box sx={{ transform: "rotate(180deg)", mt: "-4px" }}>
                <Vector color="#E24B4B" />
              </Box>
              <Typography
                fontWeight={"bold"}
                fontSize="16px"
                color="#E24B4B"
                mr="10px"
              >
                مرحله قبل
              </Typography>
            </button> */}
            <button
              style={{
                border: "none",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#6CBBC7",
                boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                padding: "12px 0px",
                marginTop: "20px",
                borderRadius: "8px",
              }}
              onClick={() => {
                if (update) {
                  setLevel(3);
                } else if (
                  dataForm.groupName !== "" &&
                  dataForm.establishYear !== "" &&
                  // dataForm.atlasCode !== "" &&
                  dataForm.totalTrips !== "" &&
                  dataForm.recentTrips !== "" &&
                  dataForm.totalMembers !== "" &&
                  dataForm.recentMembers !== "" &&
                  dataForm.managersCount !== "" &&
                  dataForm.membersPerTrip !== "" &&
                  dataForm.tripDays !== "" &&
                  dataForm.regionsCount !== "" &&
                  dataForm.pageAddress !== "" &&
                  dataForm.site !== "" &&
                  dataForm.platform !== "" &&
                  dataForm.lodgment !== "" &&
                  dataForm.groupRegistrationPlace !== "" &&
                  // dataForm.tripFrequency !== "" &&
                  dataForm.tripRadius !== "" &&
                  dataForm.address !== "" &&
                  dataForm.tel !== ""
                ) {
                  putGroupSignUp2(dataForm)
                    .then((x) => {
                      console.log(x);
                      setLevel(3);
                    })
                    .catch((err) => toast.error(err.data.msg || err.data));
                } else {
                  toast.error("فیلدهای ضروری پر شود");
                }
              }}
            >
              <Typography fontSize="16px" color="white" ml="10px">
                مرحله بعد
              </Typography>
              <Vector color="white" />
            </button>
          </Box>
        </Box>
      </Box>
    </>
  );
}
